import { BooleanInput } from '@angular/cdk/coercion';

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { CMSStorageService } from 'app/core/service/CMS-Storage.service';
import { EmployeeServiceService } from 'app/core/service/employee-service.service';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'user',
    imports: [MatButtonModule, MatMenuModule, MatIconModule, MatDividerModule]
})
export class UserComponent implements OnInit, OnDestroy {
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    user: User;

    private _unsubscribeAll: Subject<any> = new Subject<any>();
    getpersonaldetails: any;
    personalMailId: string;
    role: string;

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UserService,
        private employeeService: EmployeeServiceService,
        private cmsStorageService: CMSStorageService
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.cmsStorageService.getItem().subscribe((data) => {

            this.role = data.Role
        })
        if ((this.role == 'Financial Manager') || (this.role == 'Accounting Manager') || (this.role == 'PM')) {
            if (this.role == 'Financial Manager') {
                this.personalMailId = 'finance@coherent.in'
            } else if (this.role == 'Accounting Manager') {
                this.personalMailId = 'accounts@coherent.in'
            } else if (this.role == 'PM') {
                this.personalMailId = 'admin@coherent.in'
            }

        } else {
            this.getPersonalDetails()

        }

        // Subscribe to user changes
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) => {
                this.user = user;

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
    }
    getPersonalDetails() {
        this.employeeService.employeeOfficialDetailsView().subscribe((data: any) => {
            this.getpersonaldetails = data;
            this.personalMailId = this.getpersonaldetails?.data[0].officialMailId;

        })
    }
    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Update the user status
     *
     * @param status
     */
    updateUserStatus(status: string): void {
        // Return if user is not available
        if (!this.user) {
            return;
        }

        // Update the user
        this._userService.update({
            ...this.user,
            status,
        }).subscribe();
    }

    /**
     * Sign out
     */
    signOut(): void {
        this._router.navigate(['/sign-out']);
        localStorage.clear();
    }
    profile() {
        this._router.navigate(['/employee/employeeProfile/employeeProfile'], { queryParams: { profile: true } })
    }
}
